import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ExerciceRow } from "../../providers/exercices-provider";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { NgForOf, NgIf, NgOptimizedImage, NgStyle } from "@angular/common";
import { ExerciceCategoryThumbnailComponent } from "../exercice-category-thumbnail/exercice-category-thumbnail";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { ConfigProvider } from "../../../config-provider.service";


@Component({
  selector: 'exercice-list-card',
  templateUrl: './exercice-list-card.html',
  styleUrls: ['./exercice-list-card.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    TranslateModule,
    NgIf,
    NgForOf,
    ExerciceCategoryThumbnailComponent,
    NgOptimizedImage,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    NgStyle,
  ],
})
export class ExerciceListCardComponent {
  @Input() public exerciceRow: ExerciceRow | null = null;
  @Output() onShowClicked: EventEmitter<ExerciceRow> = new EventEmitter<ExerciceRow>();
  @Output() onDuplicateExerciceClicked: EventEmitter<ExerciceRow> = new EventEmitter<ExerciceRow>();
  @Output() onModifyExerciceClicked: EventEmitter<ExerciceRow> = new EventEmitter<ExerciceRow>();
  @Output() onDeleteExerciceClicked: EventEmitter<ExerciceRow> = new EventEmitter<ExerciceRow>();

  constructor(
    protected conf: ConfigProvider,
  ) {
  }

  public onVerticalMenuClicked($event: MouseEvent) {
    // prevent default && stop propagation
    $event.preventDefault();
    $event.stopPropagation();
  }

  public isVideoBeingTranscoded(): boolean {
    return this.exerciceRow?.exercice?.isVideoInProgress ?? false;
  }

}
